import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiPackage,
  FiCoffee,
  FiBox,
  FiDroplet,
  FiTool,
  FiRotateCcw,
  FiDownload
} from 'react-icons/fi';
import './ProcesosMenu.scss';

/**
 * Menú principal de selección de tipos de proceso
 * Basado en el diseño del PDF del cliente (página 1)
 */
const ProcesosMenu = () => {
  const navigate = useNavigate();

  const processTypes = [
    {
      type: 'TEA_PACKING',
      label: 'REGISTROS\nDE TÉS',
      icon: FiCoffee,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/tes'
    },
    {
      type: 'MAINTENANCE',
      label: 'REGISTRO\nDE MANTENIMIENTO',
      icon: FiTool,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/mantenimiento'
    },
    {
      type: 'ENCAPSULATION',
      label: 'REGISTRO\nDE ENCAPSULADO',
      icon: FiPackage,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/encapsulado'
    },
    {
      type: 'CLEANING',
      label: 'REGISTRO\nDE LIMPIEZA',
      icon: FiDroplet,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/limpieza'
    },
    {
      type: 'PACKAGING',
      label: 'REGISTRO\nDE EMPACADO',
      icon: FiBox,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/empacado'
    },
    {
      type: 'RECEIVING',
      label: 'REGISTRO PARA\nRECIBIR PRODUCTO',
      icon: FiDownload,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/recibir'
    },
    {
      type: 'RETURNS',
      label: 'REGISTRO DE RETORNO\nDE PRODUCTO',
      icon: FiRotateCcw,
      gradient: 'blue-dark-gradient',
      path: '/system/procesos/retornos'
    }
  ];

  const handleCardClick = (processType) => {
    navigate(processType.path, { state: { processType: processType.type } });
  };

  return (
    <div className="procesos-menu-page">
      <div className="procesos-menu-container">
        <h1 className="procesos-menu-title">
          REGISTROS<br/>DE PROCESOS
        </h1>

        <div className="procesos-menu-grid">
          {processTypes.map((process) => (
            <div
              key={process.type}
              className={`proceso-card ${process.gradient}`}
              onClick={() => handleCardClick(process)}
            >
              <div className="proceso-card-icon">
                <process.icon size={40} />
              </div>
              <h2 className="proceso-card-title">
                {process.label.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < process.label.split('\n').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </h2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcesosMenu;
